export default function InputCompanyEmail() {
    return {
        restrict: "E",
        scope: {
            form: "=",
            user: "=",
            validation: "=",
            label: "=",
        },
        template: require("./input-company-email.html"),

        controller: function ($scope) {
            $scope.companyMailBefore = angular.copy($scope.user.companyMail);

            $scope.checkMailUnique = function () {
                if (
                    $scope.user.companyMail &&
                    $scope.user.companyMail !== $scope.companyMailBefore
                ) {
                    // authService
                    //     .checkUniqueMail($scope.user.companyMail)
                    //     .then(function (result) {
                    //         $scope.form.companyMail.serverMessage =
                    //             result.Message;
                    //         if (result.Success) {
                    //             $scope.form.companyMail.$valid = true;
                    //             $scope.displayForgotPasswordLink = false;
                    //         } else {
                    //             $scope.form.companyMail.$valid = false;
                    //             // Add Forgotten password link
                    //             if (
                    //                 result.Message ===
                    //                 "Den indtastede email-adresse findes allerede i systemet."
                    //             ) {
                    //                 $scope.displayForgotPasswordLink = true;
                    //             }
                    //         }
                    //     });
                }
            };

            $scope.validationCheck = function () {
                $scope.form.companyMail.$valid = true;
                $scope.displayForgotPasswordLink = false;
            };
        },
    };
}
